import { MicrosoftAppType } from '../models/moovStepDefinition';

export class MicrosoftEntityDisconnectedRequest{
    public customerId!:number;
    public clientId!:number;
    public appType?:MicrosoftAppType; //missing means 'calendar'
}
